import styled from 'styled-components';
import { Header } from "components/Header";

export const Container = styled.div`
  .wrapper {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
`

export const StyledHeader = styled(Header)`
  padding: 2rem 3rem;
  border-bottom: 1px solid #3d3d3d;
  margin-bottom: 0rem;
`

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;
  overflow: hidden;
`